/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import { createApp } from 'vue';

let app=createApp({

});

app.config.globalProperties.email_pattern = '[\\w.+\\-]+@([\\w\\-]+\\.)+[\\w\\-]{2,}';  // /[\w.+\-]+@([\w\-]+\.)+[\w\-]{2,}/v
app.config.globalProperties.year = new Date().getFullYear();

import filter from "./globals/filter";
const filterUtility = new filter();
app.config.globalProperties.$filter = filterUtility;

import vueComponents from  './vueComponents';
app.use(vueComponents);

//app.component('slide-up-down','vue3-slide-up-down');

import popup from './globals/popup';
app.config.globalProperties.$popup = popup;

import LoginComponents from  './components/auth/import';
app.use(LoginComponents);

import {loadedLanguages,setI18nLanguage,loadLoginAsync,loadLanguageAsync,i18n} from "./i18n"
app.use(i18n);
window.i18n = i18n;

import routes from './login_routes';
import { createWebHistory, createRouter } from "vue-router";
const router = createRouter({
    history: createWebHistory(),
    routes
});
router.beforeEach((to, from, next) => {
    const lang = to.params.lang;
    loadLoginAsync(lang).then(()=> next());
});


app.use(router);
window.app = app;
app.mount("#app");